const layout = {
  getSidebar () {
    return "/account/user-menu";
  },
};

export default layout;
